import timeOffInputStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction("SET_TIMEOFFBALANCE_HOURS", function setTimeOffBalanceHoursInStore(requestedTimeOffBalance: number) {
    timeOffInputStore.requestedTimeOffBalance = requestedTimeOffBalance;
});
